import { Controller } from "@hotwired/stimulus"

// Switches file input accept attribute and shows/hides v1 palette select based on selected palette version
export default class extends Controller {
  static targets = ["versionSelect", "fileInput", "fileHint", "v1PaletteWrapper"]

  connect() {
    this.updateFileAccept()
  }

  updateFileAccept() {
    const version = parseInt(this.versionSelectTarget.value, 10)
    if (version === 2) {
      this.fileInputTarget.accept = ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      if (this.hasFileHintTarget) {
        this.fileHintTarget.textContent = "Выберите файл .xlsx (Excel)"
      }
      if (this.hasV1PaletteWrapperTarget) {
        this.v1PaletteWrapperTarget.style.display = ""
      }
    } else {
      this.fileInputTarget.accept = ".txt,text/plain"
      if (this.hasFileHintTarget) {
        this.fileHintTarget.textContent = "Выберите файл .txt"
      }
      if (this.hasV1PaletteWrapperTarget) {
        this.v1PaletteWrapperTarget.style.display = "none"
      }
    }
  }
}
